// Acción lista tabla altas
export const OBTENER_ALTAS_REGISTRADAS_REQUEST = 'OBTENER_ALTAS_REGISTRADAS_REQUEST';
export const OBTENER_ALTAS_REGISTRADAS_SUCCESS = 'OBTENER_ALTAS_REGISTRADAS_SUCCESS';
export const OBTENER_ALTAS_REGISTRADAS_FAIL = 'OBTENER_ALTAS_REGISTRADAS_FAIL';

// Acción obtener tabla altas
export const OBTENER_ALTAS_REQUEST = 'OBTENER_ALTAS_REQUEST';
export const OBTENER_ALTAS_SUCCESS = 'OBTENER_ALTAS_SUCCESS';
export const OBTENER_ALTAS_FAIL = 'OBTENER_ALTAS_FAIL';

// Acción anular altas
export const ANULAR_ALTAS_REQUEST = 'ANULAR_ALTAS_REQUEST';
export const ANULAR_ALTAS_SUCCESS = 'ANULAR_ALTAS_SUCCESS';
export const ANULAR_ALTAS_FAIL = 'ANULAR_ALTAS_FAIL';

// Acción registrar altas
export const REGISTRAR_ALTAS_REQUEST = 'REGISTRAR_ALTAS_REQUEST';
export const REGISTRAR_ALTAS_SUCCESS = 'REGISTRAR_ALTAS_SUCCESS';
export const REGISTRAR_ALTAS_FAIL = 'REGISTRAR_ALTAS_FAIL';

// Acción obtener etiquetas altas
export const ETIQUETAS_ALTAS_REQUEST = 'ETIQUETAS_ALTAS_REQUEST';
export const ETIQUETAS_ALTAS_SUCCESS = 'ETIQUETAS_ALTAS_SUCCESS';
export const ETIQUETAS_ALTAS_FAIL = 'ETIQUETAS_ALTAS_FAIL';

// Acción obtener reimpresion etiquetas altas
export const REIMPRESION_ETIQUETAS_ALTAS_REQUEST = 'REIMPRESION_ETIQUETAS_ALTAS_REQUEST';
export const REIMPRESION_ETIQUETAS_ALTAS_SUCCESS = 'REIMPRESION_ETIQUETAS_ALTAS_SUCCESS';
export const REIMPRESION_ETIQUETAS_ALTAS_FAIL = 'REIMPRESION_ETIQUETAS_ALTAS_FAIL';

// Acción para registrar documento de alta
export const VISADO_ALTAS_REQUEST = 'VISADO_ALTAS_REQUEST';
export const VISADO_ALTAS_SUCCESS = 'VISADO_ALTAS_SUCCESS';
export const VISADO_ALTAS_FAIL = 'VISADO_ALTAS_FAIL';

// Acción obtener firmas altas
export const OBTENER_FIRMAS_ALTAS_REQUEST = 'OBTENER_FIRMAS_ALTAS_REQUEST';
export const OBTENER_FIRMAS_ALTAS_SUCCESS = 'OBTENER_FIRMAS_ALTAS_SUCCESS';
export const OBTENER_FIRMAS_ALTAS_FAIL = 'OBTENER_FIRMAS_ALTAS_FAIL';

// Acción obtener unidades
export const OBTENER_UNIDADES_REQUEST = 'OBTENER_UNIDADES_REQUEST';
export const OBTENER_UNIDADES_SUCCESS = 'OBTENER_UNIDADES_SUCCESS';
export const OBTENER_UNIDADES_FAIL = 'OBTENER_UNIDADES_FAIL';

// Acción obtener listado estado firmantes(Firmas Altas)
export const LISTA_ESTADO_FIRMAS_REQUEST = 'LISTA_ESTADO_FIRMAS_REQUEST';
export const LISTA_ESTADO_FIRMAS_SUCCESS = 'LISTA_ESTADO_FIRMAS_SUCCESS';
export const LISTA_ESTADO_FIRMAS_FAIL = 'LISTA_ESTADO_FIRMAS_FAIL';


// Acción obtener listado estado firmantes(Estado Altas)
export const LISTA_ESTADO_REQUEST = 'LISTA_ESTADO_REQUEST';
export const LISTA_ESTADO_SUCCESS = 'LISTA_ESTADO_SUCCESS';
export const LISTA_ESTADO_FAIL = 'LISTA_ESTADO_FAIL';

// Acción obtener altas
export const LISTA_ALTAS_REQUEST = 'LISTA_ALTAS_REQUEST';
export const LISTA_ALTAS_SUCCESS = 'LISTA_ALTAS_SUCCESS';
export const LISTA_ALTAS_FAIL = 'LISTA_ALTAS_FAIL';

// Acción obtener visado completo
export const OBTIENE_VISADO_COMPLETO_REQUEST = 'OBTIENE_VISADO_COMPLETO_REQUEST';
export const OBTIENE_VISADO_COMPLETO_SUCCESS = 'OBTIENE_VISADO_COMPLETO_SUCCESS';
export const OBTIENE_VISADO_COMPLETO_FAIL = 'OBTIENE_VISADO_COMPLETO_FAIL';


// Acción obtener lista estado visadores
export const LISTA_ESTADO_VISADORES_REQUEST = 'LISTA_ESTADO_VISADORES_REQUEST';
export const LISTA_ESTADO_VISADORES_SUCCESS = 'LISTA_ESTADO_VISADORES_SUCCESS';
export const LISTA_ESTADO_VISADORES_FAIL = 'LISTA_ESTADO_VISADORES_FAIL';

// Accion que actualiza el estado de la etiqueta pasando de N a S
export const QUITAR_ETIQUETAS_REQUEST = 'QUITAR_ETIQUETAS_REQUEST';
export const QUITAR_ETIQUETAS_SUCCESS = 'QUITAR_ETIQUETAS_SUCCESS';
export const QUITAR_ETIQUETAS_FAIL = 'QUITAR_ETIQUETAS_FAIL';

// Acción que cambia el estado del las altas firmadas(firmado(1) a rechazado(2))
export const ANULAR_DOCUMENTO_VISADO_REQUEST = 'ANULAR_DOCUMENTO_VISADO_REQUEST';
export const ANULAR_DOCUMENTO_VISADO_SUCCESS = 'ANULAR_DOCUMENTO_VISADO_SUCCESS';
export const ANULAR_DOCUMENTO_VISADO_FAIL = 'ANULAR_DOCUMENTO_VISADO_FAIL';

// Acción que obtiene las altas registradas desde el modulo estado(al presionar modificar)
export const OBTENER_ALTAS_MODIFICAR_REQUEST = 'OBTENER_ALTAS_MODIFICAR_REQUEST';
export const OBTENER_ALTAS_MODIFICAR_SUCCESS = 'OBTENER_ALTAS_MODIFICAR_SUCCESS';
export const OBTENER_ALTAS_MODIFICAR_FAIL = 'OBTENER_ALTAS_MODIFICAR_FAIL';

